(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["araco-shipping-quote"]) return;
  try {
    
  const quoteForm = document.getElementById('AracoShippingQuote');
  if (quoteForm) {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('product') || '';
    const title = (params.get('title') || '').slice(0, 500);
    const variant = params.get('variant') || '';
    const rawQuantity = Number(params.get('quantity') || 1);
    const quantity = Number.isSafeInteger(rawQuantity) && rawQuantity > 0 && rawQuantity <= 9999 ? rawQuantity : 1;
    const productField = document.getElementById('QuoteProduct');
    const productGroup = document.getElementById('QuoteSelectedProduct');
    if (productField && productGroup && /^[a-z0-9][a-z0-9-]*$/.test(handle) && /^\d+$/.test(variant) && title) {
      const productUrl = new URL(window.Shopify.routes.root + 'products/' + handle, window.location.origin);
      productUrl.searchParams.set('variant', variant);
      productField.value = title + '\n' + productGroup.dataset.quantityLabel + ': ' + quantity + '\n' + productUrl.href;
      productGroup.hidden = false;
      const notes = document.getElementById('QuoteNotes');
      if (notes) {
        notes.required = false;
        const notesLabel = quoteForm.querySelector('label[for="QuoteNotes"]');
        if (notesLabel) notesLabel.textContent = notesLabel.textContent.replace(/\s*\*\s*$/, '');
      }
      const emptyBasket = document.getElementById('QuoteEmptyBasket');
      if (emptyBasket) emptyBasket.hidden = true;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
